import Utils from '../common/Utils';
import Swiper, {Navigation, Pagination} from 'swiper';
import { GLOBAL_PATH, STORE } from '../common/Model';

export default class Cmazit {
	constructor(_config) {

		this.config = _config;
		let _option = {
			type: 'api',
			service : this.config.service,
			menu : 'cmazit',
			locale : this.config.locale,
			country : this.config.country
		};
		this.cmazitApiUrl = GLOBAL_PATH(_option);
	}
	init() {
		if (Utils.isEmptyObject(STORE.data.cmazit)) {
			this.get();
		} else {
			this.render(STORE.data.cmazit);
		}
	}

	get() {
		// console.log( '# cmazit.js > get() this.cmazitApiUrl : ', this.cmazitApiUrl);
		const _this = this;
		fetch(this.cmazitApiUrl, {
			dataType: "json",
			type: "GET",
			headers: {
				'Content-Type': 'application/json', 'Accept': 'application/json'
			}
		}).then(function (response) { // The API call was successful!
			if (response.ok) {
				return response.json();
			} else {
				return Promise.reject(response);
			}
		}).then(function (data) { // This is the JSON from our response
			let _resData;
			if(data.jsonData) {
				let json = JSON.parse(data.jsonData);
				_resData = json;
			} else {
				_resData = data;
			}
			if(! _resData || _resData.length <= 0 ) return;
			STORE.data.cmazit = _resData;
			_this.render(_resData);
		}).catch(function (err) { // There was an error
			// console.warn('Something went wrong.', err);
			console.log('오류가 발생했습니다.', err);
		});

		/*$.ajax({
			dataType: "json",
			type: "GET",
			headers: {
				'Content-Type': 'application/json', 'Accept': 'application/json'
			},
			url: `${this.cmazitApiUrl}`
		})
		.fail( xhr => console.log('오류가 발생했습니다.') )
		.done(( data ) => {
			let _resData;
			if(data.jsonData) {
				let json = JSON.parse(data.jsonData);
				_resData = json;
			} else {
				_resData = data;
			}
			if(! _resData || _resData.length <= 0 ) return;
			STORE.data.cmazit = _resData;
			this.render(_resData);
		});*/
	}

	render(data) {
		const wrapper = document.querySelector('.cmazit-wrapper');
		let _title = (data.url) ? `<a href="${data.url}"><h3>${data.title}</h3><i class="icon-more"></i></a>` : `<h3>${data.title}</h3>`;
		const tmpl = this.templ(data.list, _title); // isActive:true 일 경우에만 렌더 하자
		if(data && data.list.length > 0) wrapper.innerHTML = tmpl ;
		this.addEvent();
	}

	templ(_d, _tit){
		return `
			<header class="cmazit-header">
				${_tit}
				<div class="swiper-pagination"></div>
			</header>
			<article class="cmazit-list swiper" ${this.config.isRtl ? 'dir="rtl"' : '' }>
				<div class="swiper-wrapper">
					${_d.map( (item, index) => {
						return this.listTempl(item);
					}).join('')}
				</div>
			</article>
			<div class="swiper-button-prev"></div>
			<div class="swiper-button-next"></div>`;
	}

	listTempl(_a) {
		let _hasMovie = _a.hasMovie ? `<div class="cmazit-info"><i class="icon-play"></i></div>` : ``;
		return `
			<div class="cmazit-item swiper-slide">
                <a class="cmazit-link" href="${_a.url}">
                    <div class="cmazit-thumb">${_a.thumb ? `<img src="${_a.thumb}" alt="">` : ``}
                    ${_hasMovie}</div>
                    <div class="cmazit-text">
                        <div class="cmazit-title">${_a.title}</div>
                    </div>
                </a>
            </div>`;
	}

	addEvent() {
		let cmazitSwiper = new Swiper('.cmazit-list', {
			modules: [Navigation, Pagination],
			slidesPerView: 'auto',
			slidesPerGroup: 3,
			observer: true,
			observeSlideChildren: true,
			pagination: {
				el: '.cmazit-wrapper .swiper-pagination',
				type: 'bullets',
				clickable: true
			},
			navigation: {
				nextEl: '.cmazit-wrapper .swiper-button-next',
				prevEl: '.cmazit-wrapper .swiper-button-prev'
			},
			breakpoints: {
				959: {
					// slidesPerView: 3,
					slidesPerGroup: 3
				},
			}
		});

		if (cmazitSwiper.slides.length <= 3) {
			const bullets = document.querySelectorAll(".cmazit-wrapper .swiper-pagination-bullets");
			bullets.forEach( el => {
				el.classList.add('disabled');
			});
		}

		/*window.addEventListener('resize', (evt) => {
			onWindowResize();
		});
		function onWindowResize () {
			cmazitSwiper();
		}*/

	}


}